import { GlobalTagBadge } from './GlobalTagBadge';
import { Tag as TagIcon } from 'lucide-react';

import { Badge } from '@/marketing/components/ui/badge';
import { Button } from '@/marketing/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/marketing/components/ui/popover';
import type { CampaignInfluencer } from '@/marketing/models/campaignInfluencer';
import { CampaignInfluencerTagManager } from './CampaignInfluencerTagManager';
import { useCampaignInfluencerTagAssignment } from './useCampaignInfluencerTagAssignment';

interface CampaignInfluencerTagSectionProps {
  campaignId: string;
  influencer: CampaignInfluencer;
}

export function CampaignInfluencerTagSection({ campaignId, influencer }: CampaignInfluencerTagSectionProps) {
  const { assignedTagIds, assignedTags, isAssignmentPending, toggleAssignment } = useCampaignInfluencerTagAssignment(
    campaignId,
    influencer,
  );

  return (
    <div className="tw-flex tw-flex-col tw-gap-2">
      <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-1.5">
        {assignedTags.length > 0 ? (
          assignedTags.map(({ tagId, name, isGlobal }) => (
            <Badge key={tagId} variant="secondary" className="tw-gap-1 tw-font-normal">
              <span className="tw-min-w-0 tw-truncate">{name}</span>
              {isGlobal && <GlobalTagBadge />}
            </Badge>
          ))
        ) : (
          <span className="tw-text-[12px] tw-text-muted-foreground">No tags yet.</span>
        )}
      </div>
      <Popover>
        <PopoverTrigger asChild>
          <Button variant="outline" size="sm" className="tw-w-fit tw-gap-1.5">
            <TagIcon className="tw-h-3.5 tw-w-3.5" /> Add tag
          </Button>
        </PopoverTrigger>
        <PopoverContent align="start" className="tw-w-auto tw-p-0">
          <CampaignInfluencerTagManager
            key={campaignId}
            campaignId={campaignId}
            assignedTagIds={assignedTagIds}
            isAssignmentPending={isAssignmentPending}
            onToggleAssignment={toggleAssignment}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
